export enum FormMode {
    Add = 0,
    Edit = 1,
    Read = 2
}